// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._3nNEQJZGSAfUNgCIXplw {
  display: grid;
  gap: 0.4rem;
  overflow-x: hidden;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
}

.XjBDolKgpAEXJuaCsltQ {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  box-sizing: border-box;
  width: 100%;
  padding: 0.6rem 0.8rem;
  border: 0.1rem solid var(--cl-main-disabled-transparent-2);
  border-radius: 0.6rem;
  background-color: var(--color-third);
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition:
    border-color 0.15s,
    background-color 0.15s;
}

.XjBDolKgpAEXJuaCsltQ:hover {
  background-color: var(--color-fourth-transparent-2);
}

.XjBDolKgpAEXJuaCsltQ:focus-visible {
  outline: 0.15rem solid var(--cl-main-intensive-1);
  /* Inside the card, so the scrolling list does not clip it */
  outline-offset: -0.15rem;
}

.UHraHkGSDEph0h7x9oCk,
.UHraHkGSDEph0h7x9oCk:hover {
  border-color: var(--cl-main-intensive-1);
  background-color: var(--cl-main-light-2-transparent);
}

.JeqxEVJNnkygL2tB6Uk4 {
  display: grid;
  flex-grow: 1;
  min-width: 0;
}

.RA7zl2EL1YsiASA0_jyC {
  color: var(--cl-main-dark);
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wRNXacp1THLNmYJY1duk {
  font-size: 0.85rem;
  color: var(--c-muted);
}

.iuTg1aPhwow78XY37D_i {
  flex-shrink: 0;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--cl-main-intensive-1);
  background-color: var(--cl-main-light-2-transparent);
  border-radius: 999px;
  padding: 0.1rem 0.45rem;
}
`, "",{"version":3,"sources":["webpack://./src/shared/ui/RadioCardList/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,0DAA0D;EAC1D,qBAAqB;EACrB,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf;;0BAEwB;AAC1B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,iDAAiD;EACjD,4DAA4D;EAC5D,wBAAwB;AAC1B;;AAEA;;EAEE,wCAAwC;EACxC,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,iCAAiC;EACjC,oDAAoD;EACpD,oBAAoB;EACpB,uBAAuB;AACzB","sourcesContent":[".list {\r\n  display: grid;\r\n  gap: 0.4rem;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n}\r\n\r\n.option {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.7rem;\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n  padding: 0.6rem 0.8rem;\r\n  border: 0.1rem solid var(--cl-main-disabled-transparent-2);\r\n  border-radius: 0.6rem;\r\n  background-color: var(--color-third);\r\n  font: inherit;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition:\r\n    border-color 0.15s,\r\n    background-color 0.15s;\r\n}\r\n\r\n.option:hover {\r\n  background-color: var(--color-fourth-transparent-2);\r\n}\r\n\r\n.option:focus-visible {\r\n  outline: 0.15rem solid var(--cl-main-intensive-1);\r\n  /* Inside the card, so the scrolling list does not clip it */\r\n  outline-offset: -0.15rem;\r\n}\r\n\r\n.option_chosen,\r\n.option_chosen:hover {\r\n  border-color: var(--cl-main-intensive-1);\r\n  background-color: var(--cl-main-light-2-transparent);\r\n}\r\n\r\n.option_text {\r\n  display: grid;\r\n  flex-grow: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.option_title {\r\n  color: var(--cl-main-dark);\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.option_description {\r\n  font-size: 0.85rem;\r\n  color: var(--c-muted);\r\n}\r\n\r\n.badge {\r\n  flex-shrink: 0;\r\n  font-size: 0.7rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  color: var(--cl-main-intensive-1);\r\n  background-color: var(--cl-main-light-2-transparent);\r\n  border-radius: 999px;\r\n  padding: 0.1rem 0.45rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var list = `_3nNEQJZGSAfUNgCIXplw`;
export var option = `XjBDolKgpAEXJuaCsltQ`;
export var option_chosen = `UHraHkGSDEph0h7x9oCk`;
export var option_text = `JeqxEVJNnkygL2tB6Uk4`;
export var option_title = `RA7zl2EL1YsiASA0_jyC`;
export var option_description = `wRNXacp1THLNmYJY1duk`;
export var badge = `iuTg1aPhwow78XY37D_i`;
export default ___CSS_LOADER_EXPORT___;
